import { useMemo } from 'react';
import { PayCorrectionEmployeeItem } from 'apps/sigma2-ui/src/pay-correction/components/PayCorrectionTable';

export const usePayCorrectionBudgetRecommended = ({
  listItems,
}: {
  listItems: PayCorrectionEmployeeItem[];
}) => {
  return useMemo(() => {
    return listItems.reduce((acc, curr) => {
      return acc + (curr.recommended_salary - curr.salary);
    }, 0);
  }, [listItems]);
};
